export default {
    methods: {
        checkToken(token) {
            const base64Url = token.split(".")[1];
            const base64Info = base64Url.replace(/-/g, '+').replace(/_/g, '/');
            return JSON.parse(window.atob(base64Info));
        },
        isTokenValid(token) {
            let result = true;
            const tokenExp = this.checkToken(token).exp;
            const now = ~~(Date.now() / 1000); // ~~ faster equivalent of Math.floor()

            if (tokenExp <= now) {
                result = false;
            }
            return result;
        }
    }
}